module.exports = __webpack_public_path__ + "img/library.54ddca36.png";